import script from "./LeadsCallsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadsCallsModal.vue?vue&type=script&setup=true&lang=js"

import "./LeadsCallsModal.vue?vue&type=style&index=0&id=f1f3655e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1f3655e"]])

export default __exports__